<template>
  <div>
    <template v-if="items.length > 1">
      <label
        :for="id"
        class="accessibleHide">{{ label }}</label>
      <select
        :id="id"
        :value="value"
        class="rdThemeInput"
        @change="updateValue($event.target.value)">
        <option
          v-for="item in items"
          :value="item.id"
          :key="item.id">{{ item.name }}</option>
      </select>
    </template>
    <span
      v-if="items.length == 1"
      class="singleItem">{{ items[0].name }}</span>
    <div
      v-if="showDebugIds"
      class="debugIds">{{ value }} {{ itemIndex }}:{{ items.length }}</div>
  </div>
</template>

<style scoped>
  .singleItem {
    width: auto;
    padding-right: 5px;
  }
  select {
    margin-right: 5px;
    width: 100%;
  }
</style>

<script>
import _ from 'lodash';

export default {
  name: 'StratFilter',
  props: {
    id: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    showDebugIds: {
      type: String,
      default: '',
    },
  },
  computed: {
    itemIndex() {
      return _.findIndex(this.items, { id: this.value }) + 1;
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/common/StratFilter.vue